import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
import type { User } from "../../../../../../Common/models/user";
import type { ViewWLSubscriptionsTiers } from "../../../../../../Common/models/subscriptions";

interface PaymentDrawTonightInterface {
  isMobile: boolean;
  setIsMobile: (value: boolean) => void;

  imgLoaded: boolean;
  setImgLoaded: (value: boolean) => void;

  user: User | null | undefined;
  setUser: (value: User | null | undefined) => void;

  totalEntries: number;
  setTotalEntries: (value: number) => void;

  selectedProduct: ViewWLSubscriptionsTiers | undefined;
  setSelectedProduct: (value: ViewWLSubscriptionsTiers | undefined) => void;

  onCreateFixPayment: () => void;
  setOnCreateFixPayment: (value: () => void) => void;

  resetStore: () => void;
}

const PaymentDrawTonightInterfaceStore =
  createWithEqualityFn<PaymentDrawTonightInterface>(
    (set) => ({
      isMobile: false,
      setIsMobile: (value) => set({ isMobile: value }),

      imgLoaded: false,
      setImgLoaded: (value) => set({ imgLoaded: value }),

      user: undefined,
      setUser: (value) => set({ user: value }),

      totalEntries: 0,
      setTotalEntries: (value) => set({ totalEntries: value }),

      selectedProduct: undefined,
      setSelectedProduct: (value) => set({ selectedProduct: value }),

      onCreateFixPayment: () => {},
      setOnCreateFixPayment: (value) => set({ onCreateFixPayment: value }),

      resetStore: () =>
        set({
          isMobile: false,
          imgLoaded: false,
          user: undefined,
          totalEntries: 0,
          selectedProduct: undefined,
          onCreateFixPayment: () => {},
        }),
    }),
    shallow
  );

export default PaymentDrawTonightInterfaceStore;
